
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"46","height":"46","viewBox":"0 0 46 46"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 135578","transform":"translate(-.055)"}},[_c('rect',{attrs:{"data-name":"Rectangle 111408","width":"46","height":"46","rx":"12","transform":"translate(.055)","fill":"#7367f0","opacity":".1"}}),_c('g',{attrs:{"data-name":"Group 135573"}},[_c('g',{attrs:{"fill":"none","stroke":"#7367f0","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/empty-wallet-tick"}},[_c('path',{attrs:{"d":"M30.048 25.819a2.34 2.34 0 00-.7 1.9 2.487 2.487 0 002.521 2.18h2.217v1.387a4.4 4.4 0 01-4.388 4.383H17.9a4.19 4.19 0 00.922-1.1 4.567 4.567 0 00.677-2.4 4.666 4.666 0 00-7.585-3.634v-5.094a4.4 4.4 0 014.388-4.383h13.4a4.4 4.4 0 014.388 4.383v1.679h-2.362a2.327 2.327 0 00-1.68.699z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M11.914 24.467V19.14a3.32 3.32 0 012.145-3.113l9.255-3.497a2.215 2.215 0 013 2.075v4.43","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M35.321 26.3v2.4a1.2 1.2 0 01-1.166 1.19h-2.284a2.486 2.486 0 01-2.518-2.179 2.341 2.341 0 01.699-1.9 2.323 2.323 0 011.679-.7h2.424a1.2 1.2 0 011.166 1.189z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M17.169 24h8.16","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M19.492 32.172a4.571 4.571 0 01-.676 2.4 4.189 4.189 0 01-.921 1.1 4.552 4.552 0 01-3.066 1.163 4.627 4.627 0 01-3.987-2.262 4.571 4.571 0 01-.676-2.401 4.663 4.663 0 019.326 0z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M13.01 32.171l1.154 1.158 2.483-2.3"}})])])])])
          )
        }
      }
    